/* Our Stores – live locator: loads all stores from the JSON feed, searchable list,
   map with clustered pins (Google Maps when an API key is set, otherwise Leaflet + CARTO), nearest-first */
(function () {
  var LEAFLET = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/';
  var CLUSTER = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/';
  var GCLUSTER = 'https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.min.js';
  var CACHE_KEY = 'sp-stores-feed-v2', CACHE_MS = 30 * 60 * 1000;
  var TILES = {
    voyager:  { url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', sub: 'abcd', attr: '&copy; OpenStreetMap contributors &copy; CARTO' },
    positron: { url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', sub: 'abcd', attr: '&copy; OpenStreetMap contributors &copy; CARTO' },
    osm:      { url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', sub: 'abc', attr: '&copy; OpenStreetMap contributors' }
  };
  // blue pin used on Google Maps (same look as the Leaflet pin)
  var PIN_SVG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36"><path d="M14 1C7 1 1.5 6.4 1.5 13.3 1.5 22.5 14 35 14 35s12.5-12.5 12.5-21.7C26.5 6.4 21 1 14 1z" fill="#1f97d8" stroke="#fff" stroke-width="2.5"/><circle cx="14" cy="13" r="4.5" fill="#fff"/></svg>');

  function css(href) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
  function js(src) { return new Promise(function (ok, fail) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = fail; document.head.appendChild(s); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Google Maps loader (shared with store-page.js through window.__spGoogle) */
  function loadGoogle(key) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve();
    if (window.__spGoogle) return window.__spGoogle;
    window.__spGoogle = new Promise(function (ok, fail) {
      window.__spGoogleReady = function () { ok(); };
      js('https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
        '&language=en&region=PK&loading=async&callback=__spGoogleReady').catch(fail);
      window.gm_authFailure = function () { fail(new Error('Google Maps key rejected')); document.dispatchEvent(new Event('sp:google-failed')); };
    });
    return window.__spGoogle;
  }

  function loadStores(feed) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS && c.f === feed) return Promise.resolve(c.s);
    } catch (e) {}
    var all = [], seen = {};
    function page(p) {
      return fetch(feed + '&page=' + p, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var added = 0;
        (d.stores || []).forEach(function (s) {
          var k = s.u || (s.n + '|' + s.lat + '|' + s.lng);
          if (seen[k]) return;          // never show the same store twice
          seen[k] = 1; all.push(s); added++;
        });
        if (added && d.pages && p < d.pages && p < 20) return page(p + 1);
        return all;
      });
    }
    return page(1).then(function (s) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), f: feed, s: s })); } catch (e) {}
      return s;
    });
  }

  function dist(a, b, c, d) {
    var R = 6371, r = Math.PI / 180, x = (c - a) * r, y = (d - b) * r;
    var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(y / 2) * Math.sin(y / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  /* ---------- map adapters: same 4 functions for Google and Leaflet ---------- */
  function googleMap(el, center, zoom, key, popupHtml) {
    var map, clusterer, info, markers = [];
    return {
      init: function (stores) {
        return loadGoogle(key).then(function () { return js(GCLUSTER).catch(function () {}); }).then(function () {
          map = new google.maps.Map(el, {
            center: { lat: center[0], lng: center[1] }, zoom: zoom,
            mapTypeControl: false, streetViewControl: false, fullscreenControl: true, gestureHandling: 'cooperative'
          });
          info = new google.maps.InfoWindow();
          var icon = { url: PIN_SVG, scaledSize: new google.maps.Size(28, 36), anchor: new google.maps.Point(14, 35) };
          markers = stores.map(function (s) {
            if (s.lat == null || s.lng == null) return null;
            var m = new google.maps.Marker({ position: { lat: +s.lat, lng: +s.lng }, title: s.n, icon: icon });
            m.addListener('click', function () { info.setContent('<div class="sp-gpop">' + popupHtml(s) + '</div>'); info.open({ map: map, anchor: m }); });
            return m;
          });
          var MC = window.markerClusterer && window.markerClusterer.MarkerClusterer;
          clusterer = MC ? new MC({ map: map, markers: [] }) : null;
        });
      },
      show: function (list) {
        var ms = list.map(function (s) { return markers[s._i]; }).filter(Boolean);
        if (clusterer) { clusterer.clearMarkers(); clusterer.addMarkers(ms); }
        else { markers.forEach(function (m) { if (m) m.setMap(null); }); ms.forEach(function (m) { m.setMap(map); }); }
      },
      fit: function (list, maxZoom) {
        var ms = list.map(function (s) { return markers[s._i]; }).filter(Boolean);
        if (!ms.length) return;
        var b = new google.maps.LatLngBounds();
        ms.forEach(function (m) { b.extend(m.getPosition()); });
        map.fitBounds(b, 40);
        google.maps.event.addListenerOnce(map, 'idle', function () { if (map.getZoom() > maxZoom) map.setZoom(maxZoom); });
      },
      focus: function (s) {
        var m = markers[s._i]; if (!m) return false;
        map.setZoom(16); map.panTo(m.getPosition());
        google.maps.event.trigger(m, 'click');
        return true;
      }
    };
  }

  function leafletMap(el, center, zoom, tiles, popupHtml) {
    var map, cluster, markers = [];
    return {
      init: function (stores) {
        css(LEAFLET + 'leaflet.min.css'); css(CLUSTER + 'MarkerCluster.min.css'); css(CLUSTER + 'MarkerCluster.Default.min.css');
        return js(LEAFLET + 'leaflet.min.js').then(function () { return js(CLUSTER + 'leaflet.markercluster.min.js'); }).then(function () {
          map = L.map(el, { scrollWheelZoom: false }).setView(center, zoom);
          var tl = TILES[tiles] || TILES.voyager;
          L.tileLayer(tl.url, { maxZoom: 19, subdomains: tl.sub, attribution: tl.attr }).addTo(map);
          map.on('focus', function () { map.scrollWheelZoom.enable(); });
          cluster = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 50 });
          var icon = L.divIcon({ className: 'sp-pin', html: '<span></span>', iconSize: [26, 34], iconAnchor: [13, 34], popupAnchor: [0, -30] });
          markers = stores.map(function (s) {
            if (s.lat == null || s.lng == null) return null;
            return L.marker([s.lat, s.lng], { icon: icon, title: s.n }).bindPopup(popupHtml(s));
          });
          map.addLayer(cluster);
        });
      },
      show: function (list) {
        cluster.clearLayers();
        cluster.addLayers(list.map(function (s) { return markers[s._i]; }).filter(Boolean));
      },
      fit: function (list, maxZoom) {
        var ms = list.map(function (s) { return markers[s._i]; }).filter(Boolean);
        if (ms.length) map.fitBounds(L.featureGroup(ms).getBounds(), { padding: [30, 30], maxZoom: maxZoom });
      },
      focus: function (s) {
        var m = markers[s._i]; if (!m) return false;
        cluster.zoomToShowLayer(m, function () { m.openPopup(); });
        return true;
      }
    };
  }

  function init(root) {
    if (root.__spLoc) return; root.__spLoc = true;
    var listEl = root.querySelector('[data-sp-loc-list]');
    var countEl = root.querySelector('[data-sp-loc-count]');
    var input = root.querySelector('[data-sp-loc-search]');
    var nearBtn = root.querySelector('[data-sp-loc-near]');
    var mapEl = root.querySelector('[data-sp-loc-map]');
    var max = parseInt(root.getAttribute('data-max'), 10) || 60;
    var viewLabel = root.getAttribute('data-view-label') || 'View store';
    var ofLabel = root.getAttribute('data-of-label') || '[shown] of [total] stores';
    var center = (root.getAttribute('data-center') || '30.2,69.4').split(',').map(Number);
    var zoom = parseInt(root.getAttribute('data-zoom'), 10) || 5;
    var gkey = (root.getAttribute('data-gkey') || '').trim();
    var stores = [], mapApi = null, mapReady = false, query = '', origin = null;

    function popupHtml(s) {
      return '<strong>' + esc(s.n) + '</strong><br><span>' + esc(s.ad || [s.a, s.c].join(', ')) + '</span>' +
        (s.p ? '<br><a href="tel:' + esc(String(s.p).replace(/[^\d+]/g, '')) + '">' + esc(s.p) + '</a>' : '') +
        '<br><a class="sp-pin__link" href="' + esc(s.u) + '">' + esc(viewLabel) + ' →</a>';
    }

    function matches() {
      var q = query;
      var out = !q ? stores.slice() : stores.filter(function (s) { return s._q.indexOf(q) > -1; });
      if (origin) out.sort(function (a, b) { return a._d - b._d; });
      return out;
    }

    function renderList() {
      var m = matches();
      var shown = m.slice(0, max);
      listEl.innerHTML = shown.length ? shown.map(function (s) {
        return '<li><button type="button" class="sp-loc__item" data-i="' + s._i + '">' +
          '<span class="sp-loc__name">' + esc(s.n) + '</span>' +
          '<span class="sp-loc__meta">' + esc([s.a, s.c].filter(Boolean).join(', ')) +
          (origin && s._d < 1e8 ? ' · <b>' + (s._d < 1 ? Math.round(s._d * 1000) + ' m' : s._d.toFixed(1) + ' km') + '</b>' : '') + '</span>' +
          (s.r ? '<span class="sp-loc__rating">★ ' + esc(s.r) + '</span>' : '') +
          '</button></li>';
      }).join('') : '<li class="sp-loc__loading">No stores found. Try another city or area.</li>';
      countEl.textContent = ofLabel.replace('[shown]', shown.length).replace('[total]', m.length);
      if (mapReady) {
        mapApi.show(m);
        if (query) mapApi.fit(m, 14);
      }
    }

    function focus(i) {
      var s = stores[i];
      if (!mapReady || !mapApi.focus(s)) { location.href = s.u; return; }
      if (window.innerWidth < 990) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]'); if (b) focus(+b.getAttribute('data-i'));
    });
    var t; input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { query = input.value.trim().toLowerCase(); renderList(); }, 150); });

    if (navigator.geolocation) {
      nearBtn.hidden = false;
      nearBtn.addEventListener('click', function () {
        nearBtn.classList.add('is-loading');
        navigator.geolocation.getCurrentPosition(function (p) {
          origin = [p.coords.latitude, p.coords.longitude];
          stores.forEach(function (s) { s._d = s.lat != null ? dist(origin[0], origin[1], s.lat, s.lng) : 1e9; });
          nearBtn.classList.remove('is-loading'); nearBtn.classList.add('is-active');
          renderList();
          if (mapReady) mapApi.fit(matches().slice(0, 5), 13);
        }, function () {
          nearBtn.classList.remove('is-loading');
          alert(root.getAttribute('data-error') || 'Please allow location access.');
        }, { timeout: 10000, maximumAge: 600000 });
      });
    }

    function fallback() {
      mapReady = false; mapEl.innerHTML = '';
      mapApi = leafletMap(mapEl, center, zoom, root.getAttribute('data-tiles'), popupHtml);
      return mapApi.init(stores).then(function () { mapReady = true; renderList(); }).catch(function () { mapEl.classList.add('is-error'); });
    }
    function startMap() {
      var useGoogle = !!gkey;
      if (useGoogle) document.addEventListener('sp:google-failed', function () { if (!root.__spFell) { root.__spFell = true; fallback(); } });
      mapApi = useGoogle ? googleMap(mapEl, center, zoom, gkey, popupHtml) : leafletMap(mapEl, center, zoom, root.getAttribute('data-tiles'), popupHtml);
      return mapApi.init(stores).then(function () { mapReady = true; renderList(); }).catch(function () {
        if (!useGoogle) { mapEl.classList.add('is-error'); return; }
        // Google key missing/blocked for this domain → fall back to the free English map
        if (root.__spFell) return; root.__spFell = true;
        return fallback();
      });
    }

    loadStores(root.getAttribute('data-feed')).then(function (s) {
      stores = s.map(function (x, i) { x._i = i; x._d = 1e9; x._q = [x.n, x.a, x.c, x.ad].join(' ').toLowerCase(); return x; });
      renderList();
      // load the map only when it scrolls into view
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); startMap(); } }, { rootMargin: '300px' });
        io.observe(mapEl);
      } else startMap();
    }).catch(function () {
      listEl.innerHTML = '<li class="sp-loc__loading">Could not load stores. Please browse by city below.</li>';
    });
  }

  function boot() { document.querySelectorAll('[data-sp-locator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
